import { HostQrCodeParameters, PlayerStaticImageState, PlayerVideoState, QrCodeState } from '@playcastdotio/CoreTypes';
import { makeStateStore, makeNonSerializableStateStore } from '@playcastdotio/StateStore';
import { AliasResolveResponse, Invitation, InvitationInfoResBody, KnockStatus } from '@playcastdotio/Messaging';
import { PlaycastWebrtcPresetGroup } from '@playcastdotio/Peer';
import { getPeer } from '..';
export type PlayerJoinState = {
  state:
    | 'idle'
    | 'resolvingAlias'
    | 'chooseDeck'
    | 'chooseInvite'
    | 'inQueue'
    | 'connecting'
    | 'hostConnected'
    | 'hostDisconnected'
    | 'playerDisconnected'
    | 'playerKicked';
};

const initialJoinState: PlayerJoinState = {
  state: 'idle',
};
export const joinState = makeStateStore<PlayerJoinState>(initialJoinState);

const initialPlayerNameState: { name: string } = { name: localStorage.getItem('name') || '' };
export const playerNameState = makeStateStore<{ name: string }>(initialPlayerNameState);

const initialMediaStreamState: { stream: MediaStream; audioStream: MediaStream } = {
  stream: new MediaStream(),
  audioStream: new MediaStream(),
};
export const mediaStreamState = makeNonSerializableStateStore<typeof initialMediaStreamState>(initialMediaStreamState);

export const showStaticImageState = makeStateStore<{ showStaticImage: boolean }>({
  showStaticImage: false,
});

type GamepadState = {
  playerCoordinates: {
    origin: 'topLeft' | 'bottomLeft';
    dimensions: { x: number; y: number };
    display: { x: number; y: number };
  };
  gamepads: Gamepad[];
};
const initialGamepadState: GamepadState = {
  playerCoordinates: {
    origin: 'topLeft',
    dimensions: { x: 0, y: 0 },
    display: { x: window.screen.width, y: window.screen.height },
  },
  gamepads: [],
};
export const gamepadState = makeNonSerializableStateStore<GamepadState>(initialGamepadState);

const intialAuthStateStore = {
  accessToken: '',
  email: '',
  playerAuthId: '',
};
export const authStateStore = makeStateStore(intialAuthStateStore);

const initialVideoState: PlayerVideoState = { enabled: false, streamId: '' };
export const playerVideoState = makeStateStore(initialVideoState);

const initialStaticImageState: PlayerStaticImageState = {
  staticImageBase64: '',
};
export const playerStaticImageState = makeStateStore(initialStaticImageState);

const initialQrCodeState: QrCodeState = {
  defaultPlayerState: {
    content: '',
    enabled: false,
    scale: 1,
    position: {
      x: 0,
      y: 0,
    },
    anchor: {
      x: 0,
      y: 0,
    },
  },
  players: {},
};
export const playerQrCodeState = makeStateStore(initialQrCodeState);

const initialHostQrCodeState: HostQrCodeParameters = {
  showTo: 'all',
  hideWhen: 'never',
};
export const hostQrCodeState = makeStateStore(initialHostQrCodeState);

// type KnockState = {
//   knockId: string;
//   status: KnockStatus | 'idle';
//   queuePosition?: number;
//   queueDescription?: string;
// };
// const initialKnockState: KnockState = {
//   knockId: '',
//   status: 'idle',
// };
// export const knockState = makeStateStore(initialKnockState);

const initialLobbyState = {
  position: 0,
  accepted: false,
  rejected: false,
  broadcastHostId: '',
};
export const lobbyState = makeStateStore(initialLobbyState);

const initialHostQualityPresets = {} as PlaycastWebrtcPresetGroup;
export const hostQualityPresets = makeStateStore(initialHostQualityPresets);
// hostQualityPresets.addListener((state) => {
//   getPeer()?.setQualityPresetGroup(state);
// });

export const replicatedStores = {
  playerVideoState,
  playerStaticImageState,
  playerQrCodeState,
  hostQrCodeState,
  showStaticImageState,
  hostQualityPresets,
};

type HostConnectionState = {
  playerPeerId: string;
  broadcastSessionId: string;
  status: 'idle' | 'connecting' | 'connected' | 'disconnected' | 'failed' | 'refused';
  iceServers?: {
    urls: string[];
    username: string;
    credential: string;
  };
  allowPeerConnections: boolean;
};
export const hostConnectionState = makeStateStore<HostConnectionState>({
  status: 'idle',
  playerPeerId: '',
  broadcastSessionId: '',
  allowPeerConnections: true,
});

// type InvitationState = {
//   selectedInvite: InvitationInfoResBody | undefined;
//   invites: { [inviteId: string]: InvitationInfoResBody | false };
// };
// export const invitationState = makeStateStore<InvitationState>({ invites: {}, selectedInvite: undefined });

type InvitationState2 = {
  success: boolean;
  selectedInvite: Invitation | undefined;
  invitationPlayerId: string;
  isAlias: boolean;
  invites: { [inviteId: string]: Invitation | false };
};
export const invitationState2 = makeStateStore<InvitationState2>({
  success: true,
  isAlias: false,
  invites: {},
  invitationPlayerId: '',
  selectedInvite: undefined,
});

export const joinIdState = makeStateStore<string>('');

// const initialDeckState: AliasResolveResponse & { selectedDeck: string } = {
//   selectedDeck: '',
//   decks: [],
// };
// export const deckState = makeStateStore(initialDeckState);

const initialDeckState2: {
  invitations: Invitation[];
  name: string;
  greeting: string;
} = {
  invitations: [],
  name: '',
  greeting: '',
};

export const deckState2 = makeStateStore(initialDeckState2);

const initialRuleState = {
  requireAuthOnDeck: false,
  autoJoinFromQueue: true,
};
export const ruleState = makeStateStore(initialRuleState);
